import React from "react";

export const Team = (props) => {
  return (
    <div id="team" style={{ background: "#f9fafb", padding: "60px 0" }}>
      <div className="container">
        {/* Section Title */}
        <h2
          style={{
            textAlign: "center",
            fontWeight: 800,
            fontSize: "clamp(24px, 5vw, 48px)", // responsive font
            marginBottom: 12,
          }}
        >
          OUR BRANDS
        </h2>
        <div
          style={{
            width: 120,
            height: 4,
            background: "#025e20",
            opacity: 0.25,
            margin: "0 auto 40px auto",
            borderRadius: 2,
          }}
        />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 32,
            maxWidth: 1100,
            margin: "0 auto",
            padding: "0 16px", // padding for small screens
          }}
        >
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={d.name || i}
                  style={{
                    display: "flex",
                    flexDirection: i % 2 === 0 ? "row" : "row-reverse",
                    alignItems: "center",
                    gap: 40,
                    background: "#fff",
                    borderRadius: 16,
                    padding: "24px",
                    boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                    border: "1px solid #f0f0f0",

                    /* 📱 Responsive stacking */
                    flexWrap: "wrap",
                  }}
                >
                  {/* Image */}
                  {d.img && (
                    <img
                      src={d.img}
                      alt={d.name}
                      style={{
                        width: "100%",
                        maxWidth: 250,
                        height: "auto",
                        objectFit: "contain",
                        flexShrink: 0,
                        borderRadius: 12,
                        background: "#fdfdfd",
                        margin: "0 auto", // center on mobile
                      }}
                    />
                  )}

                  {/* Text Content */}
                  <div style={{ flex: 1, minWidth: "250px" }}>
                    <h3
                      style={{
                        fontWeight: 700,
                        fontSize: "clamp(20px, 4vw, 28px)", // responsive
                        marginBottom: 12,
                        color: "#111827",
                        textAlign: "left",
                      }}
                    >
                      {d.name}
                    </h3>
                    <ul
                      style={{
                        listStyle: "none",
                        padding: 0,
                        margin: 0,
                        fontSize: "clamp(15px, 2.5vw, 17px)", // responsive text
                        color: "#374151",
                      }}
                    >
                      {d.descriptions &&
                        d.descriptions.map((desc, idx) => (
                          <li
                            key={idx}
                            style={{
                              marginBottom: 10,
                              lineHeight: 1.6,
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            {/* ✔ for first 3 cards only */}
                            {i <= 2 && (
                              <span
                                style={{
                                  color: "#025e20",
                                  fontWeight: "bold",
                                }}
                              >
                                ✔
                              </span>
                            )}
                            {desc}
                          </li>
                        ))}
                    </ul>
                  </div>
                </div>
              ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
